module.exports = __webpack_public_path__ + "static/media/Flight-Time.4869f7f8.svg";